module.exports = __webpack_public_path__ + "static/5-fa2d12093b3f81d06ed2986f98233bac.jpeg";